module.exports = __webpack_public_path__ + "media/images/Account-0e6da889d3dfd6a413775715d10c09e9.svg";